import { paypal_connection_error_message } from "../constants/others_constants"
import { check_paypal_connection_api } from "../constants/endpoints/firebase"

export default async paypal_client_id => {
  const { data } = await check_paypal_connection_api(paypal_client_id)

  return data && !data.includes(paypal_connection_error_message)
}
